var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 3.17157 3.67157 2.5 4.5 2.5H12.5C13.3284 2.5 14 3.17157 14 4V9C14 9.82843 13.3284 10.5 12.5 10.5H8.5V9.5H12.5C12.7761 9.5 13 9.27614 13 9V4C13 3.72386 12.7761 3.5 12.5 3.5H4.5C4.22386 3.5 4 3.72386 4 4H3.5C3.32735 4 3.15981 4.02188 3 4.06301V4ZM14.5 12.5H8.5V11.5H14.5C14.7761 11.5 15 11.7239 15 12C15 12.2761 14.7761 12.5 14.5 12.5ZM4.5 12.5C4.77614 12.5 5 12.2761 5 12C5 11.7239 4.77614 11.5 4.5 11.5C4.22386 11.5 4 11.7239 4 12C4 12.2761 4.22386 12.5 4.5 12.5ZM1.5 6.5C1.5 5.67157 2.17157 5 3 5H6C6.82843 5 7.5 5.67157 7.5 6.5V12.5C7.5 13.3284 6.82843 14 6 14H3C2.17157 14 1.5 13.3284 1.5 12.5V6.5ZM3 6C2.72386 6 2.5 6.22386 2.5 6.5V12.5C2.5 12.7761 2.72386 13 3 13H6C6.27614 13 6.5 12.7761 6.5 12.5V6.5C6.5 6.22386 6.27614 6 6 6H3Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevices);
export default __webpack_public_path__ + "static/media/icon_devices.966d14f99daabf45586211271d41a75f.svg";
export { ForwardRef as ReactComponent };